module.exports = __webpack_public_path__ + "img/us.8886b28b.svg";